var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-component"},[_c('div',{staticClass:"tools"},[_c('div',{staticClass:"tool-item top",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('svg-icon',{attrs:{"icon-class":"zd"}})],1)]),_c('RetrievalsCode',{ref:"RetrievalsCode"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }